import { defineComponent as _defineComponent } from 'vue'
import { computed } from '../../../adapter-vue';
import TUIChatEngine, { IMessageModel } from '@tencentcloud/chat-uikit-engine';

interface IProps {
  message: IMessageModel;
  signalingInfo: any;
  customContent: any;
  blinkMessageIDList?: string[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'message-call-group',
  props: {
    message: { default: () => ({}) as IMessageModel },
    signalingInfo: { default: () => ({}) },
    customContent: { default: () => ({}) },
    blinkMessageIDList: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { message: IMessageModel, signalingInfo: any, customContent: any, blinkMessageIDList: string[] }



const TYPES = TUIChatEngine.TYPES;
const isCallMessage = computed(() => !!props.signalingInfo);
const conversationType = computed(() => props.message?.conversationType);
const custom = computed(() => props.customContent?.custom);

const isBlink = computed(() => {
  if (props.message?.ID) {
    return props.blinkMessageIDList?.includes(props.message.ID);
  }
  return false;
});

return { __sfc: true,props, TYPES, isCallMessage, conversationType, custom, isBlink }
}

})